import cloneDeep from 'lodash.clonedeep';

import baseView from '../../base-view';
import template from './template.hbs';

const notification = baseView.make();

notification.container = document.body;
notification.template = template;

notification.render = function () {
  const styleBody = () => {
    const paddingTop = this.el ? this.el.offsetHeight : 0;
    document.body.style.paddingTop = `${paddingTop}px`;
  };

  const renderMarkup = () => {
    const html = this.template(this.getContext());

    this.container.insertAdjacentHTML('afterbegin', html);
    this.el = this.container.firstElementChild;
    this.el.view = this;
    styleBody();
  };

  const addListeners = () => {
    const onResize = styleBody.bind(this);
    const closeButton = this.el.querySelector('.notification__close');

    window.addEventListener('resize', onResize);
    closeButton.addEventListener('click', () => {
      this.close()
        .then(styleBody)
        .then(() => {
          window.removeEventListener('resize', onResize)
        });
    });
  };

  return Promise.resolve()
    .then(renderMarkup)
    .then(addListeners);
};

const make = cloneDeep.bind(null, notification);

export default {
  make
};
